import { render, staticRenderFns } from "./RequestRg.vue?vue&type=template&id=317e0dbb&scoped=true"
import script from "./RequestRg.vue?vue&type=script&lang=js"
export * from "./RequestRg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317e0dbb",
  null
  
)

export default component.exports